import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import pkg from './package.json';

export function getNegativeKeywordsListsGridFactory(initializeGlobalContext = true) {
  if (initializeGlobalContext) {
    return globalContext.define(
      pkg.legacyDependencies,
      Promise => import(/* webpackMode: 'eager' */ './src/factory') // eslint-disable-line no-unused-vars
    );
  }
  return import(/* webpackMode: 'eager' */ './src/factory'); // eslint-disable-line no-unused-vars
}
